export const env = {
  SETTLD_ENV: import.meta.env.VITE_SETTLD_ENV,
  VERSION: import.meta.env.VITE_VERSION,
  // Backend configuration
  BACKEND_HOST: import.meta.env.VITE_BACKEND_HOST,
  DOMAIN: import.meta.env.VITE_DOMAIN,

  // Analytics and tracking
  GA_ID: import.meta.env.VITE_GA_ID,
  GTM_ID: import.meta.env.VITE_GTM_ID,

  // Third-party services (with fallbacks)
  APPSIGNAL_KEY: import.meta.env.VITE_APPSIGNAL_KEY || "",
} as const;

// Helper functions for common environment checks
export const isDevelopment = () => env.SETTLD_ENV === "development" || env.SETTLD_ENV === "dev";
export const isStaging = () => env.SETTLD_ENV === "staging";
export const isProduction = () => env.SETTLD_ENV === "production";

// Type-safe environment access
export type Environment = typeof env;
